import { render, staticRenderFns } from "./process_k.vue?vue&type=template&id=ef1cef6c&scoped=true"
import script from "./process_k.vue?vue&type=script&lang=js"
export * from "./process_k.vue?vue&type=script&lang=js"
import style0 from "./process_k.vue?vue&type=style&index=0&id=ef1cef6c&prod&lang=css"
import style1 from "./process_k.vue?vue&type=style&index=1&id=ef1cef6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1cef6c",
  null
  
)

export default component.exports